'use strict';

require('./InventoryReport.scss');
const React = require('react');
const {TextField} = require('material-ui');
const moment = require('moment');

const OrderUtils = require('utils/OrderUtils');
const {INVENTORY_MAX_PAST_DAYS_SCOPE} = require('constants/AppConstants');
const {t} = require('services/i18nextWrapper');
const {FloatingActionButton, Table, TableHeader, TableRow, TableRowColumn, TableHeaderColumn, TableBody} = require('material-ui');
const NumberUtils = require('utils/NumberUtils');
const DateUtils = require('utils/DateUtils');

const WIDTH_DESCRIPTION_ITEM = '30%';

const InventoryReport = React.createClass({displayName: "InventoryReport",
  
  propTypes: {
    orders: React.PropTypes.array,
    items: React.PropTypes.array,
    itemSelected: React.PropTypes.object,
    locationItems: React.PropTypes.array,
    vendorPurchaseItems: React.PropTypes.array,
    isVisible: React.PropTypes.bool,
    onClose: React.PropTypes.func,
    onSelectItem: React.PropTypes.func,
    dateFrom: React.PropTypes.string,
    dateTo: React.PropTypes.string
  },
  
  componentDidUpdate(prevProps) {
    if (!prevProps.isVisible && this.props.isVisible) {
      this.timeout = setTimeout(() => {
        this.refs.filterReport.getDOMNode().querySelector('input').focus();
      }, 750);
    } else if (prevProps.isVisible && !this.props.isVisible) {
      this.cleanTimeouts();
    }
  },
  
  getInitialState() {
    return {
      limitInventoryCalculate: DateUtils.getByDateFromNowInDays(-INVENTORY_MAX_PAST_DAYS_SCOPE),
      filterName: ''
    };
  },
  
  cleanTimeouts() {
    clearTimeout(this.timeout || 0);
  },
  
  render() {
    const {
      isVisible,
      orders,
      onClose,
      items,
      dateFrom,
      dateTo,
      locationItems,
      itemSelected,
      vendorPurchaseItems
    } = this.props;
    const {limitInventoryCalculate, filterName} = this.state;
  
    const groupTotalsByItem = getTotalByItemsId(orders, limitInventoryCalculate);
    const stockByItemId = getRealStockByItemId(locationItems);
    const requestedByItemId = getRequestedByItemId(vendorPurchaseItems);
    const itemsFiltered = getItemsRow(groupTotalsByItem, stockByItemId, requestedByItemId, items);
    const setFilterByName = (name) => this.setState({filterName: name});
    const cleanFilterByName = () => this.setState({filterName: ''}, () => this.refs.filterReport.setValue('')); // it's not enough to clean the state, you need to clean it from DOM puajj);
    const onChangeFilterByName = getOnChangeFilterByName(setFilterByName);
    const displayDateFrom = moment(dateFrom).format('ll');
    const displayDateTo = moment(dateTo).format('ll');
    const itemsAlreadyFiltered = itemsFiltered
    .filter(item => {
      if (!filterName) return true;
      return item.name.toLowerCase().includes(filterName.toLowerCase());
    });
    return (
      React.createElement("div", {className: `inventory-report ${isVisible ? 'is-active' : ''}`}, 
        React.createElement("div", {className: "inventory-report__header"}, 
          React.createElement("div", {className: "report-title"}, 
            React.createElement("h3", null, t('dashboard_inventory_report_title')), 
            React.createElement("h4", null, t('date-from'), ": ", DateUtils.isBeforeToDay(displayDateFrom)
              ? limitInventoryCalculate // don't show before limit inventory calculation
              : displayDateFrom, 
            " - ", t('date-to'), ": ", displayDateTo)
          ), 
          React.createElement("div", null, 
            React.createElement(TextField, {
              floatingLabelText: `${t('dashboard_inventory_report_filter_name')}`, 
              className: "filter-report", 
              fullWidth: true, 
              onChange: onChangeFilterByName, 
              ref: "filterReport"
            }
            )
          ), 
          React.createElement("div", {className: "btn-close"}, 
            React.createElement(FloatingActionButton, {
              onClick: () => {
                cleanFilterByName();
                onClose();
              }, 
              iconClassName: "muidocs-icon-action-grade", backgroundColor: "#B3B3B3"}, 
              React.createElement("i", {className: "material-icons md-38 btn-icon-center"}, "close")
            )
          )
        ), 
        React.createElement("div", {className: "inventory-report__content"}, 
          React.createElement(Table, {
            selectable: true, 
            fixedHeader: true, 
            multiSelectable: false, 
            onRowSelection: ([index]) => {
              if (index !== undefined) {
                const itemFiltered = itemsAlreadyFiltered[index] || {};
                const targetItem = (items || []).find(item => +item.id === +itemFiltered.itemId);
                this.props.onSelectItem(targetItem);
              } else {
                this.props.onSelectItem(undefined);
              }
            }
          }, 
            React.createElement(TableHeader, {className: "admin-table-header"}, 
              React.createElement(TableRow, {className: "admin-table-header-row"}, 
                React.createElement(TableHeaderColumn, {style: {width: `${WIDTH_DESCRIPTION_ITEM} !important`}}, 
                  t('name')
                ), 
                React.createElement(TableHeaderColumn, null, 
                  t('dashboard_inventory_report_column_stock_item')
                ), 
                React.createElement(TableHeaderColumn, null, 
                  t('dashboard_inventory_report_column_reserved_item')
                ), 
                React.createElement(TableHeaderColumn, null, 
                  t('dashboard_inventory_report_column_missing_item')
                ), 
                React.createElement(TableHeaderColumn, null, 
                  t('dashboard_inventory_report_column_requested_item')
                ), 
                React.createElement(TableHeaderColumn, null, 
                  t('dashboard_inventory_report_column_virtual_stock')
                )
              )
            ), 
            React.createElement(TableBody, {className: "admin-table-body", 
                       deselectOnClickaway: false}, 
              itemsAlreadyFiltered.map(item => {
                return (
                  React.createElement(TableRow, {selected: itemSelected && itemSelected.id === +item.itemId, key: `key-${item.itemId}`}, 
                    Object.keys(item)
                      .filter(key => key !== 'itemId')
                      .map((key, index) => React.createElement(TableRowColumn, {
                        style: index === 0 ? {width: `${WIDTH_DESCRIPTION_ITEM} !important`} : {}
                      }, item[key]))
                    
                  )
                );
              })
            )
          )
        ), 
        React.createElement("div", {className: "inventory-report__footer"}
        
        )
      )
    );
  }
});


function getOnChangeFilterByName(setFilterByName) {
  return (evt) => {
    setFilterByName(evt.target.value);
  };
}

function getTotalByItemsId(orders, limitInventoryCalculate) {
  const allItems = OrderUtils.getAllWhereInventoryWasTakenFromAllItemsFromAllProductsFromOrders(orders, limitInventoryCalculate);
  const groupTotalsByItem = allItems
  .filter(
    item => item.type === 'LOCATION_ITEM_MODULE' ||
      item.type === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE' ||
      item.type === 'VENDOR_PURCHASE_ITEM_MODULE'
  )
  .reduce((total, whereInventory) => {
    
    const {to, from, itemIdKey} = (whereInventory.type === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE')
      ? {to: 'totalMissing', from: 'amountItemNeeded', itemIdKey: 'itemIdNeeded'}
      : {to: 'totalReserved', from: 'amountSubtracted', itemIdKey: 'itemId'};
    
    const itemId = whereInventory[itemIdKey];
    
    if (!total[itemId]) {
      total[itemId] = {
        totalMissing: 0,
        totalReserved: 0,
        totalRequested: 0
      };
    }
    
    const value = total[itemId][to];
    total[itemId][to] = +NumberUtils.sum(value, whereInventory[from] || 0);
    
    return total;
    
  }, {});
  return groupTotalsByItem;
}

function getRealStockByItemId(locationItems) {
  return locationItems.reduce((total, locationItem) => {
    const itemId = locationItem.item.id;
    if (total[itemId]) {
      total[itemId] = NumberUtils.sum(total[itemId], locationItem.amount);
    } else {
      total[itemId] = locationItem.amount;
    }
    return total;
  }, {});
}

function getRequestedByItemId(vendorPurchaseItems) {
  return vendorPurchaseItems
  /**
   * The reserved requested items only matters the state `ORDERED`.
   * The rest of the sates it doesn't matters because:
   *
   *  - "NO_MORE_ON_THE_WAY" & REJECT_REMAINDER": Because these state means that real stock was affected.
   *  - "PENDING": Because the provider doesn't receive the email yet.
   */
  .filter(vendorPurchaseItem => vendorPurchaseItem.state === 'ORDERED')
  .reduce((total, vendorPurchaseItem) => {
    const itemId = vendorPurchaseItem.itemId;
    const amountRequested =  NumberUtils.multiply(vendorPurchaseItem.relativeUnitAmount || 1, vendorPurchaseItem.amountRequested);
    if (total[itemId]) {
      total[itemId] = NumberUtils.sum(total[itemId], amountRequested);
    } else {
      total[itemId] = amountRequested;
    }
    return total;
  }, {});
}

function getItemsRow(groupTotalsByItem, stockByItemId, requestedByItemId, items) {
  const itemsFiltered = Object.keys(groupTotalsByItem)
  .map((itemId) => {
    const stock = NumberUtils.formatDecimal(stockByItemId[itemId] || 0);
    const amountRequested = NumberUtils.formatDecimal(requestedByItemId[itemId] || 0);
    let amountReserved = NumberUtils.formatDecimal(groupTotalsByItem[itemId]['totalReserved'] || 0);
    const amountMissingItems = NumberUtils.formatDecimal(groupTotalsByItem[itemId]['totalMissing'] || 0);
  
    // Virtual stock = real stock + purchased - (stock reserved + purchased reserved)
    const rawVirtualStock = NumberUtils.formatDecimal(
      NumberUtils.subtract(NumberUtils.sum(stock, amountRequested), amountReserved)
    );
  
    /**
     * In case of missing items grather than 0, we should take as a reference that will be the virtual stock, because the
     * missing item is already taking in account all stock reserved and also purchased reserved too.
     * In case of missing with 0, we should calulcate the virtual stock, which was actually calculated above.
     */
    const virtualAmount = NumberUtils.isGreater(amountMissingItems, 0)
      ? `-${amountMissingItems}`
      : rawVirtualStock;
    
    return { // The order of the following properties matters, it's the way that will display in the table
      itemId,
      name: ((items || []).find(item => item.id === +itemId) || {description: ''}).description,
      stock,
      amountReserved,
      amountMissingItems,
      amountRequested,
      virtualAmount
    };
  }).sort((a, b) =>
    NumberUtils.isEqual(a.virtualAmount, b.virtualAmount)
      ? 0
      : NumberUtils.isGreater(a.virtualAmount, b.virtualAmount)
      ? 1
      : -1
  );
  return itemsFiltered;
}

module.exports = InventoryReport;


/** WEBPACK FOOTER **
 ** ./src/components/InventoryReport/InventoryReport.jsx
 **/